import { render, staticRenderFns } from "./AddNewSchoolGrade.vue?vue&type=template&id=c67ab8ca&"
import script from "./AddNewSchoolGrade.vue?vue&type=script&lang=js&"
export * from "./AddNewSchoolGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports